var CharacterFlow;
(function (CharacterFlow) {
    CharacterFlow["GET_CHARACTER"] = "GetCharacter";
    CharacterFlow["CREATE_CHARACTER"] = "CreateCharacter";
    CharacterFlow["UPDATE_CHARACTER"] = "UpdateCharacter";
    CharacterFlow["DELETE_CHARACTER"] = "DeleteCharacter";
    CharacterFlow["GENERATE_AVATAR_IMAGE"] = "GenerateAvatarImage";
    CharacterFlow["EDIT_AVATAR_IMAGE"] = "EditAvatarImage";
    CharacterFlow["SAVE_AVATAR_IMAGE"] = "SaveAvatarImage";
    CharacterFlow["CREATE_TRANSLATION"] = "CreateTranslation";
    CharacterFlow["GET_TRANSLATION"] = "GetTranslation";
    CharacterFlow["REPORT_CHARACTER"] = "ReportCharacter";
    CharacterFlow["SUGGEST_FIELD"] = "SuggestField";
    CharacterFlow["SUGGEST_TAGS"] = "SuggestTags";
})(CharacterFlow || (CharacterFlow = {}));
// Character Translation Types
var CharacterTranslationTaskStatus;
(function (CharacterTranslationTaskStatus) {
    CharacterTranslationTaskStatus["PENDING"] = "PENDING";
    CharacterTranslationTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    CharacterTranslationTaskStatus["COMPLETED"] = "COMPLETED";
    CharacterTranslationTaskStatus["FAILED"] = "FAILED";
    CharacterTranslationTaskStatus["CANCELLED"] = "CANCELLED";
    CharacterTranslationTaskStatus["NOT_FOUND"] = "NOT_FOUND";
})(CharacterTranslationTaskStatus || (CharacterTranslationTaskStatus = {}));
var CharacterType;
(function (CharacterType) {
    CharacterType["STANDARD"] = "STANDARD";
    CharacterType["META"] = "META";
})(CharacterType || (CharacterType = {}));
var LoraStatus;
(function (LoraStatus) {
    LoraStatus["READY"] = "ready";
    LoraStatus["PENDING"] = "pending";
})(LoraStatus || (LoraStatus = {}));
export { CharacterFlow, CharacterTranslationTaskStatus, CharacterType, LoraStatus };
